module.exports = __webpack_public_path__ + "media/Act_OneDraft_Audio.c651da6f.mp3";